import React from 'react';
import styles from './AppointmentInfoDialog.scss';
import { formatAppointmentDate, getStatusLabel, getTypeLabel } from '../Appointments';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

const AppointmentInfoDialog = ({ appointment }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.AppointmentInfoDialog}>
      <div className={styles.Header}>
        <div className={styles.Labels}>
          {getStatusLabel(appointment.status, t)}
          {getTypeLabel(appointment.type, t)}
        </div>
        <div className={styles.Title}>
          <div className={styles.ObjectName}>{appointment.buildingName}</div>
          <div className={styles.Address}>{appointment.buildingAddress}</div>
        </div>
      </div>
      <div className={styles.Divider} />
      <div className={styles.Content}>
        <div className={styles.InfoField}>
          <div className={styles.FieldName}>{t('components.profile.appointments.dateAndTime')}</div>
          <div className={styles.FieldText}>
            {formatAppointmentDate(appointment.dateTimeFrom, t, i18next.language)}
          </div>
        </div>
        <div className={styles.InfoField}>
          <div className={styles.FieldName}>{t('components.profile.appointments.clientName')}</div>
          <div className={styles.FieldText}>{appointment.firstNameClient}</div>
        </div>
        <div className={styles.InfoField}>
          <div className={styles.FieldName}>{t('components.profile.appointments.clientDate')}</div>
          <div className={styles.FieldText}>{appointment.phoneClient}</div>
        </div>
        {appointment.comment && (
          <div className={styles.InfoField}>
            <div className={styles.FieldName}>{t('components.profile.appointments.comment')}</div>
            <div className={styles.FieldText}>{appointment.comment}</div>
          </div>
        )}
        <div className={styles.InfoField}>
          <div className={styles.FieldName}>{t('components.profile.appointments.agentName')}</div>
          <div className={styles.FieldText}>
            {appointment.firstNameAgent} {appointment.lastNameAgent}
          </div>
        </div>
        {appointment.agencyName && (
          <div className={styles.InfoField}>
            <div className={styles.FieldName}>{t('components.profile.appointments.agency')}</div>
            <div className={styles.FieldText}>{appointment.agencyName}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AppointmentInfoDialog;



// WEBPACK FOOTER //
// ./src/components/Profile/Appointments/AppointmentDialog/AppointmentInfoDialog.jsx